import { Language } from '@/shared/model/Language';

export const localeToLang = (locale: string) => {
    return locale.toUpperCase().replace('-', '_') as Language;
};
